import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, user } = useAuthStore();
  const { tenantId: urlTenantId } = useParams();

  if (!isAuthenticated) {
    // Redirect to tenant login if tenant context exists, otherwise global login
    const loginPath = urlTenantId ? `/${urlTenantId}/login` : '/login';
    return <Navigate to={loginPath} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    // Redirect to appropriate dashboard based on role and tenant context
    const basePath = urlTenantId ? `/${urlTenantId}` : '';
    const roleRoute = {
      admin: `${basePath}/dashboard`,
      super_admin: urlTenantId ? `${basePath}/dashboard` : '/super-admin',
      parent: `${basePath}/parent`,
      employee: `${basePath}/employee`,
    };
    return <Navigate to={roleRoute[user?.role] || '/login'} replace />;
  }

  return children;
};

export default ProtectedRoute;
